import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  container: {
    // position: "absolute",
    boxSizing: "content-box",
    minHeight: "100vh",
    marginBottom: -200,
    marginTop: -70,
    "@media (max-width:600px)": {
      marginBottom: -380,
    },
    width: "100%",
    // background: `linear-gradient(to right,  #d8d0fa, #cbbfff,#140c41)`, //77.3343
    background:
      "linear-gradient(90deg, rgba(216,208,250,1) 0%, rgba(193,184,231,1) 32%, rgba(178,168,219,1) 46%, rgba(169,159,212,1) 56%, rgba(157,146,202,1) 67%, rgba(147,136,195,1) 74%, rgba(134,122,184,1) 79%, rgba(80,68,142,1) 99%)",
  },
  padding70: {
    paddingTop: 70,
    paddingBottom: 200,
    "@media (max-width:600px)": {
      paddingBottom: 380,
    },
  },
});

export default function ({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.padding70}>{children}</div>
    </div>
  );
}
